export default __webpack_public_path__ + "static/media/location.beac5529.svg";